import { fetchApi } from '@/app/api';
import { AdminAccountPatch, parseAdminAccountDto } from '@certhon/models';
import { map } from 'remeda';

export function fetchAccounts() {
  return fetchApi('/admin/accounts').then(map(parseAdminAccountDto));
}

export function fetchAccount(id: number) {
  return fetchApi(`/admin/accounts/${id}` as '/admin/accounts/:recnum').then(
    parseAdminAccountDto,
  );
}

export function updateAccount(patch: AdminAccountPatch) {
  return fetchApi(
    `/admin/accounts/${patch.recnum}` as '/admin/accounts/:recnum',
    undefined,
    {
      method: 'PATCH',
      body: JSON.stringify(patch),
    },
  ).then(parseAdminAccountDto);
}
